export const SIGN_OUT = '@@SECURITY_FUND/SIGN_OUT';

export const actionCreators = {
    signOut: () => ({
        type: SIGN_OUT
    }), 
};
